import { render, staticRenderFns } from "./AppMobNav.vue?vue&type=template&id=f8bd2de2&scoped=true&"
import script from "./AppMobNav.vue?vue&type=script&lang=js&"
export * from "./AppMobNav.vue?vue&type=script&lang=js&"
import style0 from "./AppMobNav.vue?vue&type=style&index=0&id=f8bd2de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bd2de2",
  null
  
)

export default component.exports